import { useFocusRing } from 'react-aria'

export const useFocusVisible = (forceFocus?: boolean) => {
  // `react-aria` uses element.focus() in `useButton` breaking `:focus-visible` on macOS on all browsers - see https://bugzilla.mozilla.org/show_bug.cgi?id=1618639#c10
  const { focusProps, isFocusVisible: isRealFocusVisible } = useFocusRing()
  const isFocusVisible = forceFocus || isRealFocusVisible
  return { focusProps, isFocusVisible }
}
